import React from 'react';

const FooterBlock = () => {
  return (
    <footer className="footer bg-[var(--midnight)] text-[var(--bone)] py-20 text-center relative z-10 px-6 overflow-hidden">
      <img src="/brand/logo.png" alt="Sonakshi & Shubham" className="w-24 md:w-28 h-auto mx-auto mb-6" />
      <div className="names font-serif text-2xl tracking-wide mb-4">Sonakshi &amp; Shubham</div>
      <div className="tag text-sm tracking-widest uppercase text-[var(--bone)]/60 mb-12">With love <span className="mx-2">·</span> From Kanpur &amp; Patna <span className="mx-2">·</span> In Jaipur</div>
      <div className="small text-xs tracking-wider text-[var(--bone)]/40 flex flex-col gap-2">
        <div>© 2026 · Designed with love for Sonakshi &amp; Shubham</div>
      </div>
    </footer>
  );
};

export default FooterBlock;
